<!-- 联系我们 -->
<template>
  <div id="contact">
    <section>
      <div class="cover">
        <address>
          <h1>您可以填写右边的表格，我们会尽快与您联系。您也可以按照以下电话和地址与我们取得联系。</h1>
          <div class="phone">400-622-8098</div>
          <div class="mes">200030</div>
          <div class="address">上海市徐汇区中山南二路107号<br/>美奂大厦11层A单元</div>
          <h2>在地图上找我们</h2>
          <a href="http://map.baidu.com/?newmap=1&s=inf%26uid%3D11f3652ca38d1d70077ce835%26wd%3D%E7%BE%8E%E5%A5%82%E5%A4%A7%E5%8E%A6%26all%3D1%26c%3D289&from=alamap&tpl=map_singlepoint" target="_blank">
            <img src="/imgs/portal/contact/shanghai@2x.jpg" alt="map" class="map">
          </a>
        </address>
        <div class="form">
          <h1>联系我们</h1>
          <el-input v-model.trim="userName" placeholder="怎么称呼您" class="user-name"></el-input>
          <el-select v-model.trim="questionType" placeholder="选择问题类型">
              <el-option label="融资问题" value="融资问题"></el-option>
              <el-option label="供应商注册问题" value="供应商注册问题"></el-option>
              <el-option label="银行或其他金融机构" value="银行或其他金融机构"></el-option>
              <el-option label="企业推荐" value="企业推荐"></el-option>
          </el-select>
          <el-input v-model.trim="cellphone" placeholder="客户手机号或邮箱"></el-input>
          <el-input v-model.trim="companyName" placeholder="您的公司名称"></el-input>
          <el-input type="textarea" :rows="4" placeholder="问题描述" v-model.trim="questionDetail"></el-input>
          <el-button type="primary" @click="login">提交</el-button>
        </div>
      </div>
    </section>
    <portal-footer></portal-footer>
  </div>
</template>

<script>
import baseVueOptions from '@/assets/js/BaseVueOptions'
import cookieUtils from '@/assets/js/CookieUtils'
import { isCellphone, isMail, getMainDomain } from '@/assets/js/CommonUtils'
import Footer from './Footer'

export default {
  extends: baseVueOptions,
  components: {
    'portal-footer': Footer
  },
  data () {
    return {
      userName: '', // 客户姓名
      questionType: '', // 问题类型
      cellphone: '', // 联系方式
      companyName: '', // 企业名称
      questionDetail: '' // 其他问题
    }
  },
  methods: {
    sendMes () {
      let vm = this
      let dataObj = {
        email: 'wanglong.jin@iqunxing.com',
        cellphone: this.cellphone,
        userName: this.userName,
        companyName: this.companyName,
        questionType: this.questionType,
        questionDetail: this.questionDetail
      }
      vm.ajax({
        type: 'POST',
        url: '/api/message/scene/send',
        data: JSON.stringify({
          appId: '1048',
          code: '官网-希望联系客户信息',
          createBy: 'user',
          data: JSON.stringify(dataObj)
        }),
        success (res) {
          vm.$alert('我们的顾问会在24小时内与您取得联系', '提交成功')
          vm.cellphone = ''
          vm.userName = ''
          vm.companyName = ''
          vm.questionType = ''
          vm.questionDetail = ''
        },
        error (res) {
          vm.$alert('请重新填写并提交信息', '提交失败')
        }
      })
    },
    login () {
      let vm = this
      if (vm.userName === '') {
        vm.$alert('请填写联系人名字', '提示')
        return
      }
      if (!isCellphone(vm.cellphone) && !isMail(vm.cellphone)) {
        vm.$alert('联系方式有误，请重新填写联系方式', '提示')
        return
      }
      if (vm.questionType === '') {
        vm.$alert('请选择问题类型', '提示')
        return
      }
      if (vm.companyName === '') {
        vm.$alert('请填写公司名称', '提示')
        return
      }
      let param = {}
      param.cellphone = '17611405175'
      param.password = '123456yw'
      this.ajax({
        url: '/api/user/v2/public/login', // f21之后得版本v2改成v3
        type: 'POST',
        data: JSON.stringify(param),
        success: function (res) {
          cookieUtils.set('tk', res.data.token, {
            domain: getMainDomain()
          })
          setTimeout(function () {
            vm.sendMes()
          }, 500)
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~@/assets/css/utils";
@import "../css/theme-config";
#contact{
  margin-top: 96px;
  background: #fff;
}
section{
  background: url(/imgs/portal/contact/bg_contact@2x.png) center center no-repeat;
  background-size: cover;
  height: 704px;
  color: #fff;
  .cover{
    width: 1000px;
    margin: 0 auto;
    address{
      width: 302px;
      display: inline-block;
      margin-right: 80px;
      font-weight: normal;
      font-style: normal;
      padding: 78px 0 68px;
      vertical-align: top;
      h1{
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: rgba(255,255,255,0.80);
        letter-spacing: 0.5px;
        text-align: justify;
        line-height: 30px;
        font-weight: normal;
        margin-bottom: 48px;
      }
      div{
        margin-bottom: 20px;
        padding-left: 36px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #FFFFFF;
        letter-spacing: 0.5px;
        line-height: 16px;
        &.phone{
          background: url(/imgs/portal/contact/Phone@2x.png) left center no-repeat;
          background-size: 15px 16px;
        }
        &.mes{
          background: url(/imgs/portal/contact/Message@2x.png) left center no-repeat;
          background-size: 16px 11px;
        }
        &.address{
          background: url(/imgs/portal/contact/Shape@2x.png) 3px 6px no-repeat;
          background-size: 12px 16px;
          line-height: 24px;
        }
      }
      h2{
        font-weight: normal;
        font-family: PingFangSC-Regular;
        font-size: 30px;
        color: #FFFFFF;
        letter-spacing: 0.5px;
        line-height: 30px;
        margin: 47px 0 22px;
      }
      .map{
        width: 100%;
      }
    }
    .form{
      display: inline-block;
      vertical-align: top;
      background: #fff;
      box-shadow: 0 29px 40px 0 rgba(0,0,0,0.62);
      border-radius: 4px;
      padding: 50px 80px;
      box-sizing: border-box;
      width: 610px;
      height: 610px;
      margin-top: 47px;
      h1{
        font-family: PingFangSC-Medium;
        font-size: 36px;
        color: #333333;
        letter-spacing: 1.5px;
        text-align: center;
        line-height: 36px;
        font-weight: normal;
        margin: 0 auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Contact.vue?9bf4b71e